var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPayshapInfo4 = function SvgPayshapInfo4(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3168_6914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3544 4.48633H7.45117C5.79432 4.48633 4.45117 5.82948 4.45117 7.48633V68.4863C4.45117 70.1432 5.79432 71.4863 7.45117 71.4863H40.3544C42.0113 71.4863 43.3544 70.1432 43.3544 68.4863V30.4218V7.48633C43.3544 5.82947 42.0112 4.48633 40.3544 4.48633Z",
    stroke: "#F15A22",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2168 20.7949V24.8044",
    stroke: "#F15A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4258 26.6088L31.3327 23.7019",
    stroke: "#F15A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2305 30.8188H34.24",
    stroke: "#F15A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4258 35.0288L31.3327 37.9357",
    stroke: "#F15A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2168 36.833V40.8425",
    stroke: "#F15A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0996 37.9357L20.0065 35.0288",
    stroke: "#F15A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1914 30.8188H18.2009",
    stroke: "#F15A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0996 23.7019L20.0065 26.6088",
    stroke: "#F15A22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 48.5,
    width: 26,
    height: 2,
    fill: "#FC4D0F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 54.5,
    width: 26,
    height: 8,
    rx: 1,
    fill: "#F15A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.59351C18.5 8.92311 19.0435 8.37964 19.7139 8.37964H27.6041C28.2745 8.37964 28.8179 8.92311 28.8179 9.59351C28.8179 10.2639 28.2745 10.8074 27.6041 10.8074H19.7139C19.0435 10.8074 18.5 10.2639 18.5 9.59351Z",
    fill: "#F15A22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 14.208,
    width: 32.0759,
    height: 32.0759,
    rx: 3,
    fill: "#F15A22",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7433 22.5134H40.1658C39.6913 22.5134 39.3066 22.8981 39.3066 23.3726V25.9501C39.3066 26.4246 39.6913 26.8093 40.1658 26.8093H42.7433C43.2179 26.8093 43.6025 26.4246 43.6025 25.9501V23.3726C43.6025 22.8981 43.2179 22.5134 42.7433 22.5134Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9113 22.5134H51.3338C50.8593 22.5134 50.4746 22.8981 50.4746 23.3726V25.9501C50.4746 26.4246 50.8593 26.8093 51.3338 26.8093H53.9113C54.3858 26.8093 54.7705 26.4246 54.7705 25.9501V23.3726C54.7705 22.8981 54.3858 22.5134 53.9113 22.5134Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7433 33.6826H40.1658C39.6913 33.6826 39.3066 34.0673 39.3066 34.5418V37.1193C39.3066 37.5938 39.6913 37.9785 40.1658 37.9785H42.7433C43.2179 37.9785 43.6025 37.5938 43.6025 37.1193V34.5418C43.6025 34.0673 43.2179 33.6826 42.7433 33.6826Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7705 33.6826H52.193C51.7372 33.6826 51.3002 33.8637 50.9779 34.1859C50.6556 34.5082 50.4746 34.9452 50.4746 35.401V37.9785",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7715 37.9785V37.9885",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0381 25.95V28.5275C47.0381 28.9832 46.857 29.4203 46.5348 29.7425C46.2125 30.0648 45.7755 30.2458 45.3197 30.2458H42.7422",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3066 30.2458H39.3167",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0391 22.5134H47.0491",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0391 33.6826V33.6926",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4746 30.2458H51.3338",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7715 30.2458V30.2559",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0391 37.9786V37.1194",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3168_6914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayshapInfo4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payshap_info_4.feda74f8.svg";
export { ForwardRef as ReactComponent };